export const isColorLight = (hexColor: string) => {
  const red = parseInt(`${hexColor[1]}${hexColor[2]}`, 16);
  const green = parseInt(`${hexColor[3]}${hexColor[4]}`, 16);
  const blue = parseInt(`${hexColor[5]}${hexColor[6]}`, 16);
  return red * 0.299 + green * 0.587 + blue * 0.114 > 186;
};

export const getFontColor = (backgroundHexColor: string) => {
  return isColorLight(backgroundHexColor) ? '#333333' : 'white';
};

export const TAG_COLORS = [
  '#D11B59',
  '#D41000',
  '#920101',
  '#9C27B0',
  '#5C23C2',
  '#570265',
  '#006794',
  '#001DBD',
  '#00776B',
  '#127A16',
  '#155200',
  '#B75800',
  '#DC3500',
  '#AC2900',
  '#653B2C',
  '#647882',
];
